/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetAvgPriceAndMortgageRateModel,
  IGetAvgPriceAndMortgageRateRequest,
  IMappers,
  IGetAvgPriceAndMortgageRateResponse,
  IGetAvgPriceAndMortgageRateResponseError,
  TGetAvgPriceAndMortgageRateResponse,
} from './types';

const defaultConfig: TGetAvgPriceAndMortgageRateModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'investment-calculator',
  pathApi: '/v1/get-avg-price-and-mortgage-rate/',
  hostType: 'api',
} as TGetAvgPriceAndMortgageRateModel;

function createGetAvgPriceAndMortgageRateModel(
  parameters: IGetAvgPriceAndMortgageRateRequest,
): TGetAvgPriceAndMortgageRateModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetAvgPriceAndMortgageRateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetAvgPriceAndMortgageRateRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetAvgPriceAndMortgageRate<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetAvgPriceAndMortgageRateOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetAvgPriceAndMortgageRateResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetAvgPriceAndMortgageRateModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetAvgPriceAndMortgageRateResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetAvgPriceAndMortgageRateResponseError);
    }
  }

  return { response, statusCode } as TGetAvgPriceAndMortgageRateResponse;
}

export { defaultConfig, createGetAvgPriceAndMortgageRateModel, fetchGetAvgPriceAndMortgageRate };
